import { render, staticRenderFns } from "./PapelSeguranca.vue?vue&type=template&id=ba25ed82&scoped=true&"
import script from "./PapelSeguranca.vue?vue&type=script&lang=js&"
export * from "./PapelSeguranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba25ed82",
  null
  
)

export default component.exports